import {createRouter, createWebHistory} from 'vue-router'

export const constantRoutes = [
    {
        path: '/user/login',
        name: '登录',
        component: () => import('../views/login')
    }, {
        path: '/',
        component: () => import('../layout/BasicLayout'),
        redirect: '/dashboard',
        children: [
            {
                path: '/dashboard',
                name: '工作台',
                component: () => import('../views/dashboard')
            }, {
                path: '/dept/goods/sort',
                name: '门店菜品排序',
                component: () => import('../views/dept/goods/sort')
            }
        ]
    }, {
        path: '/',
        component: () => import('../layout/BasicLayout'),
        redirect: '/ai',
        children: [
            {
                path: '/ai',
                name: '大鸽AI',
                meta: {
                    title: '大鸽AI', tag: '大鸽AI'
                },
                component: () => import('../views/ai')
            }
        ]
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes: constantRoutes
})

export default router
